'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.abort = exports.post = exports.get = exports.ajax = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _Deferred = require('./Deferred');

var _Deferred2 = _interopRequireDefault(_Deferred);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 对ajax的封装,支持promise回调
 * @module xhr2
 * @author alanzhang <alanzhang@futunn.com>
 */
exports.ajax = ajax;
exports.get = get;
exports.post = post;
exports.abort = abort;

/*global JSON Map*/

// 用于存放promise和xhr的对应关系
var xhrmap = new _map2.default();

// 存放group名称与promise的对应关系
var groupMap = new _map2.default();

var PARAMS = '_xhr2Params';

/**
 * 工具方法
 * @module
 * @private
 */
var commonUtil = {
    /**
     * [keys description]
     * @param  {Object} obj  对象
     * @return {Array} keys 数组
     */
    keys: function keys(obj) {
        if (!obj) {
            return [];
        }

        var result = [];

        for (var k in obj) {
            if (obj.hasOwnProperty(k)) {
                result.push(k);
            }
        }
        return result;
    },


    /**
     * [serializeArray 将map格式的数据转换为二维数组[ [key,value],[key,value] ]]
     * @function
     * @param  {*} data [description]
     * @param  {Booelean} encodeAble [是否需要转义]
     * @return {Array}      [description]
     */
    serializeToArray: function serializeToArray(data, encodeAble) {
        var args = [];

        if (!data) {
            return args;
        }

        if (data instanceof Object) {
            this.keys(data).forEach(function (key) {
                var item = data[key];
                if (Array.isArray(item)) {
                    var arrayName = key + '[]';
                    item.forEach(function (_item) {
                        args.push([arrayName, encodeAble ? encodeURIComponent(_item) : _item]);
                    });
                } else {
                    args.push([key, encodeAble ? encodeURIComponent(item) : item]);
                }
            });
        } else {
            args.push([data.toString()]);
        }

        return args;
    },


    // 是否在服务端
    isServer: function isServer() {
        return typeof document === 'undefined';
    },
    isIE9: function isIE9() {
        if (this.isServer()) return false;
        return (/MSIE 9.0/gi.test(navigator.userAgent)
        );
    },


    /**
     * [serialize 将map结构序列换]
     * @param  {Array} data [description]
     * @param  {Boolean} encodeAble [是否进行转义]
     * @return {String}     [description]
     */
    serializeToString: function serializeToString(data, encodeAble) {
        var args = this.serializeToArray(data, encodeAble);
        var result = args.map(function (item) {
            return item.join('=');
        });

        return result.join('&');
    },


    /**
     * 通过value找到map的第一个key
     * @param {Map} map [map]
     * @param {*} searchValue [value]
     * @return {*} [promise]
     */
    getByMapValue: function getByMapValue(map, searchValue) {
        var p = null;
        map.forEach(function (value, key) {
            if (!p) {
                if (value === searchValue && key) {
                    p = key;
                }
            }
        });
        return p;
    }
};

// 生成类型检测工具方法,避免使用typeof, typeof 会被 babel (兼容判断 Symbol )，增加约 400 行代码
['Function', 'String', 'Object'].forEach(function (typeName) {
    commonUtil['is' + typeName] = function (obj) {
        return Object.prototype.toString.call(obj) === '[object ' + typeName + ']';
    };
});

/**
 * 发起ajax请求时的一些工具方法
 * @module
 * @private
 */
var ajaxUtil = {
    /**
     * 合并参数
     * @function
     * @param {Object} defaultOption 默认参数
     * @param {Object} option 用户参数
     * @returns {Object} 最终参数
     */
    mixinOption: function mixinOption(defaultOption, option) {
        if (!(commonUtil.isString(option.group) && option.group.length > 0)) {
            delete option.group;
        }
        var _option = (0, _assign2.default)(true, {}, defaultOption, option);
        _option.type = String(_option.type).toUpperCase();
        _option.dataType = String(_option.dataType).toUpperCase();

        return _option;
    },


    /**
     * get请求时，生成url
     * @function
     * @param {Boolean} isCache 是否缓存
     * @param {Object} data 请求参数对象或者其他简单数据类型
     * @param {String} url 请求url
     * @returns {string} get请求的url
     */
    generateGetUrl: function generateGetUrl(isCache, data, url) {
        var searchStr = '';
        var requestUrl = '';

        if (!isCache) {
            data = (0, _assign2.default)({}, data, {
                '_': +new Date()
            });
        }

        searchStr = commonUtil.serializeToString(data, true);

        if (searchStr.length > 0) {
            requestUrl = url + (requestUrl.indexOf('?') === -1 ? '?' : '&') + searchStr;
        }

        return requestUrl;
    },


    /**
     * 生成post请求是的data参数
     * @function
     * @param {*} data 请求参数对象或者其他数据类型
     * @param {String} dataType 数据发送的形式
     * @returns {Object|String} 需要发送的data数据
     */
    generateData: function generateData(data, dataType) {
        var formData = null;

        if (data instanceof FormData) {
            formData = data;
        } else if (data instanceof Object && dataType === 'FORM') {
            var dataArray = commonUtil.serializeToArray(data);
            formData = new FormData();
            dataArray.forEach(function (item) {
                formData.append(item[0], item[1]);
            });

            if (formData.isPolyfill) {
                formData = formData.toString();
            }
        } else if (data instanceof Object && dataType === 'JSON') {
            formData = (0, _stringify2.default)(data);
        } else {
            formData = data.toString();
        }
        return formData;
    },


    /**
     * 请求的url是否跨域，如果域名不完全相同，则认为是跨域
     * @function
     * @param {string} requestUrl 请求url
     * @returns {boolean} 是否跨域
     */
    isCrossDomain: function isCrossDomain(requestUrl) {
        return (/^(?:(?:https?:)?\/\/)/gi.test(requestUrl) && new RegExp('(?:https?:)?\/\/' + document.domain.replace(/\./gi, '\\.') + '(/|$)', 'gi').test(requestUrl) === false
        );
    },


    /**
     * 实例化xhr对象
     * @function
     * @param {String} requestUrl 请求url
     * @return {Object} xhr对象
     */
    generateXhr: function generateXhr(requestUrl) {
        // IE9及以下，跨域访问需要使用特别的xdomainrequest来处理
        // 此处IE10仍然支持XDomainRequest，所以不方便使用能力检测，而是使用版本检测
        var isIE9Cors = this.isCrossDomain(requestUrl) && commonUtil.isIE9();
        var xhrObject = isIE9Cors ? new XDomainRequest() : new XMLHttpRequest();
        return xhrObject;
    },


    /**
     * abort掉互斥的请求
     * @function
     * @param {string} group abort掉其他名称相同的请求
     * @param {Object} params 额外的参数
     * @returns {undefined}
     */
    abortGroupXhr: function abortGroupXhr(group, params) {
        if (group.length === 0) {
            return;
        }
        if (!commonUtil.isObject(params)) {
            params = {};
        }
        var _promise = groupMap.get(group);
        // abort 请求
        abort(_promise, (0, _assign2.default)(params, {
            abortCallBy: 'xhr2,abortGroupXhr',
            group: group
        }));
        groupMap.delete(group);
    },


    /**
     * 保存标志与promise的对应关系
     * @function
     * @param {string} group 互斥的名称
     * @param {object} promiseObj promise对象
     * @returns {undefined}
     */
    addGroupXhr: function addGroupXhr(group, promiseObj) {
        groupMap.set(group, promiseObj);
    },


    /**
     * [isComplete 判断某个请求是否结束]
     * @param  {String}  group [xhr的group字段]
     * @return {Boolean}       [请求是否结束]
     */
    isComplete: function isComplete(group) {
        var _promise = groupMap.get(group);
        if (!_promise) {
            return true;
        }

        var _xhr = xhrmap.get(_promise);
        if (!_xhr || _xhr.isComplete) {
            return true;
        }

        return false;
    },
    xhrDone: function xhrDone(xhr, deferred) {
        if (xhr) {
            xhr.isComplete = true;
        }
        xhrmap.delete(deferred.promise);
    },


    /**
     * 设置header
     * @function
     * @param {Object} xhr xhr对象
     * @param {Object} header header map
     * @return {undefined}
     */
    setXhrHeader: function setXhrHeader(xhr, header) {
        if (xhr.setRequestHeader) {
            commonUtil.keys(header).forEach(function (headerKey) {
                xhr.setRequestHeader(headerKey, header[headerKey]);
            });
        }
    }
};

/**
 * 如果浏览器不支持FormData则自定义FormData，最后通过toString方法转换成需要传输的数据格式
 * @function
 * @private
 * @param  {Boolean} isSupportFD [是否支持FromData]
 * @return {undefined}
 */
~function () {

    if (commonUtil.isServer()) return; // 服务端渲染

    // 判断是否支持FormData，IE9及以下不支持
    var isSupportFormData = 'FormData' in window;

    if (isSupportFormData) {
        return;
    }
    window.FormData = function () {
        this.data = {};
    };

    // 标志当前对象为模拟对象而非原生
    window.FormData.prototype.isPolyfill = true;

    /**
     * [append 将key value保存在data中]
     * @param  {string} key   [添加元素名称]
     * @param  {string|number|array} value [添加元素的值，可为对象，数组，数组元素不可为复杂对象]
     * @returns {undefined}
     */
    window.FormData.prototype.append = function (key, value) {
        this.data[key + ''] = value;
    };

    /**
     * 转换data为key=value&key=value
     * @function
     * @returns {string} 形如key=value&key=value的字符串
     */
    window.FormData.prototype.toString = function () {
        return commonUtil.serializeToString(this.data, true);
    };
}();

/**
 * 通用ajax方法,返回promise对象。
 * @function
 * @static
 * @since 2.0.0
 * @param {Object} option - ajax 必选，参数对象
 * @param {string} option.url - 必选，请求的url
 * @param {string} option.type - 必选，请求的类型，目前只支持'get',post'
 * @param {Object} [option.data] - 可选，请求的数据，可为对象或者JSON对象
 * @param {Boolean} [option.isCache] - 可选，是否缓存请求，默认值: false,设置为 false 将不缓存
 * @param {String} [option.dataType] - 可选，发送data的方式，可为'FORM'或'JSON'，发送时，分别对应请求头multipart/form-data(IE9 上为application/x-www-form-urlencoded）、application/json
 * @param {Object} [option.header] - 可选，设置请求的header，格式为{haeder-key:header-value}，注意，IE9中，跨域请求时，无法设置header。
 * @param {String} [option.group] - 可选，用于标志当前请求的id名称，在当前请求发起之前(后)，同group的请求将会被abort掉，可通过firstActive字段来控制保留最后一个请求还是第一个请求
 * @param {Boolean} [option.firstActive] - 可选，在设定了group字段时，可控制保留第一个还是最后一个请求，默认为false，多个请求重名时，保留最后一个请求，为true时，保留第一个请求，第一个请求在发送时，后面的请求不进行发送
 * @param {Number} [option.timeout] - 可选，请求超时时间，默认为20000ms，超时后请求仍然未成功，则请求会被abort掉
 * @param {Function} [option.uploadProgress] - 可选，对于支持formdata上传的环境，提供uploadProgress方法，处理上传进度
 * @param {function} [option.beforeSend] - 可选，发送请求前可修改 XMLHttpRequest及附加发送数据的函数。例如设置header，设置withCredentials等。
 * 参数为xhr,无返回值。
 * @returns {Object} Promise对象，请求成功时，resolve状态的参数为请求返回值，请求失败时，reject状态的参数为包含message和isabort,isrepeat的对象。message表示错误原因，isabort为boolean值，表示请求是否为取消上面的请求导致的失败，当用户手动abort请求，或者请求互斥，接口超时时，isabort为true；isAbort
 * isrepeat表示，firstActive为true时，某次请求在进行中时，后面的同名请求因为重复请求被取消
 *
 * @example
 * xhr.ajax({
 *     url: './server.php',
 *     type: 'get',
 *     isCache: false,   // 请求是否缓存，默认为false，即为url加上随机值
 *     dataType:'form'   // 默认以form的方式发送
 *     timeout: 30000,   // 定义超时时间，默认为20000ms
 *     group: 'test',    // 如果2个及以上的request都标有同一个group，则只有最后一个能发送，前面均会被abort掉，可不填
 *     header: {         // 自定义header
 *          'xx-header':'xxx'
 *     },
 *     beforeSend: function(xhr) {
 *          // 请求发送前，再做点更改
 *          //xhr.setHeader();
 *     },
 *     data:{
 *         name:'rick',
 *         email:'rick@futunn.com'
 *     }
 * }).then(function(ret){
 *     // 请求成功
 *     console.log(ret);
 * },function(e){
 *     // 请求失败
 *     console.log(e.message);
 * });
 */
function ajax(option) {
    //  默认配置
    var defaultOption = {
        url: '',
        // 默认为get方式
        type: 'GET',
        data: {},
        dataType: 'FORM',
        // 类型：Boolean;默认值: false,设置为 false 将不缓存
        isCache: false,
        // 用于标志当前xhr请求的名称，如果存在其他相同名称的请求A，则将会A 请求abort掉
        //group:'',
        //存在同名名称的请求时，保留最先发送的请求还是最后发送的请求，默认为false，保留最后发送的请求
        firstActive: false,
        // 默认是异步请求
        async: true,
        // 请求超时时间
        timeout: 20000,
        header: {},
        // 发送请求前可修改 XMLHttpRequest 对象的函数，扩展此方法以便提供更多修改
        // 更多设置可参考 https://www.w3.org/TR/2006/WD-XMLHttpRequest-20060405/
        beforeSend: function beforeSend(xhrObj) {}
    };

    // 组装参数
    var _option = ajaxUtil.mixinOption(defaultOption, option);
    // 判断请求是否跨域了，对于IE9，跨域请求需要使用XDomainRequest
    var xhr = ajaxUtil.generateXhr(_option.url);
    var deferred = new _Deferred2.default();

    // abort掉同名请求
    if (_option.hasOwnProperty('group')) {
        // 是否保留最先发送的请求
        if (_option.firstActive) {
            // 请求是否结束，如果未结束则直接返回，否者继续发送请求
            if (ajaxUtil.isComplete(_option.group) === false) {
                xhr = null;
                deferred.reject({ message: 'request uninstalled', isrepeat: true, status: 0, params: { reason: '同名请求被 abort' } });
                return deferred.promise;
            }
        } else {
            ajaxUtil.abortGroupXhr(_option.group, {
                reason: '同名请求被 abort'
            });
        }
    }

    var formData = null;
    // 支持get，post请求,其他方法需要设定header
    switch (_option.type) {
        case 'GET':
            _option.url = ajaxUtil.generateGetUrl(_option.isCache, _option.data, _option.url);
            break;
        case 'POST':
            formData = ajaxUtil.generateData(_option.data, _option.dataType);
            break;
        default:
            formData = ajaxUtil.generateData(_option.data, _option.dataType);
    }

    // XDomainRequest 的事件绑定方式
    if (xhr.toString().indexOf('XDomainRequest') > -1) {
        // XDomainRequest 不需要判断status
        xhr.onload = function () {
            ajaxUtil.xhrDone(xhr, deferred);
            clearTimer(xhr);
            loadText(xhr.responseText);
        };
        xhr.open(_option.type, _option.url, _option.async);
    } else {
        // 为确保进度正常，必须保证process事件在open之前
        xhr.upload && (xhr.upload.onprogress = _option.uploadProgress);
        xhr.open(_option.type, _option.url, _option.async);
        xhr.onload = function (e) {
            ajaxUtil.xhrDone(xhr, deferred);
            clearTimer(xhr);
            if (this.status >= 200 && this.status <= 209 || this.status === 304) {
                loadText(xhr.responseText);
            } else {
                // 记录错误信息是否是组件赋予还是接口赋予
                e.errMsgDIY = !e.hasOwnProperty('message');
                e.message = e.message || '请求失败,status:' + this.status;
                e.isabort = false;
                e.status = this.status;
                deferred.reject(e);
            }
        };
    }

    // 只有发生了网络层级别的异常才会触发此事件，对于应用层级别的异常，
    // 如响应返回的xhr.statusCode是4xx时，并不属于Network error，所以不会触发onerror事件
    xhr.onerror = function (e) {
        ajaxUtil.xhrDone(xhr, deferred);
        // 记录错误信息是否是组件赋予还是接口赋予
        e.errMsgDIY = !e.hasOwnProperty('message');
        e.message = e.message || '请求失败';
        e.isabort = false;
        e.status = 0;
        deferred.reject(e);
    };

    // 请求被取消
    xhr.onabort = function () {
        ajaxUtil.xhrDone(xhr, deferred);
        deferred.reject({ message: 'request canceled', isabort: true, status: 0, params: xhr[PARAMS] || null });
    };

    /**
     * [loadText 请求返回数据的回调]
     * @function
     * @private
     * @param  {String} responseText [description]
     * @return {undefined} undefined
     */
    function loadText(responseText) {
        var ret = null;
        var parseOk = false;
        try {
            ret = JSON.parse(responseText);
            parseOk = true;
        } catch (e) {
            deferred.reject(new Error('cant`t convert responseText to json,expect a json string,url is ' + _option.url + ',responseText is:' + responseText));
        }
        parseOk && deferred.resolve(ret);
    }

    /**
     * [clearTimer 清除xhr的超时，用于设置了超时，但是请求正常返回的情况]
     * @function
     * @param  {Object} xhrObj [description]
     * @return {undefined}
     */
    function clearTimer(xhrObj) {
        xhrObj && xhrObj.timer && clearTimeout(xhr.timer);
    }

    // 对于不支持formData的浏览器，通过自定义formData来处理，需要设置header为form格式
    if (_option.dataType === 'FORM' && FormData.prototype.isPolyfill) {
        ajaxUtil.setXhrHeader(xhr, {
            'Content-type': 'application/x-www-form-urlencoded'
        });
    } else if (_option.dataType === 'JSON') {
        ajaxUtil.setXhrHeader(xhr, {
            'Content-type': 'application/json'
        });
    }

    //设置自定义header
    ajaxUtil.setXhrHeader(xhr, _option.header);

    // 在发送请求前仍然可对xhr属性进行更改，可对数据再次更改
    _option.beforeSend(xhr);
    xhr.send(formData);

    // 存在超时时间,xhr设置timeout存在兼容性，且XDomainRequest.ontimeout不推荐使用
    // 故通过setimeout模拟
    if (Number(_option.timeout) > 0 && xhr) {
        xhr.timer = setTimeout(function () {
            var p = commonUtil.getByMapValue(xhrmap, xhr);
            abort(p, {
                reason: '请求超时导致 abort',
                abortCallBy: 'xhr2,ajax,setTimeout',
                timeout: _option.timeout
            });
        }, _option.timeout);
    }

    // 保存promise和xhr的对应关系
    xhrmap.set(deferred.promise, xhr);
    // 保存xhr名称与promise的对应关系
    if (_option.hasOwnProperty('group')) {
        xhr.group = _option.group;
        ajaxUtil.addGroupXhr(_option.group, deferred.promise);
    }
    return deferred.promise;
}

/**
 * 对请求正确与否做一层封装
 * @function
 * @private
 * @param {Object}   params 必选，ajax的参数
 * @param {Object}   [filter] 可选，指定成功的参数配置
 * @returns {Object} Promise对象
 */
function send(params, filter) {
    var filterData = (0, _assign2.default)({
        codeName: 'code',
        msgName: 'message',
        defaultErrorMsg: '网络异常，请稍后再试',
        dataName: '',
        parser: null
    }, filter);

    /**
     * resolveRet 内部方法在服务端有返回数据的条件下，判断此次业务请求是否成功
     * @private
     * @function
     * @param  {JSON} ret  请求返回结果
     * @param  {Function|String} code 如果为函数，则需要返回boolean值，用于表明请求是否成功，如果为string则根据ret中对应字段来判断]
     * @return {Boolean} [true，则认为请求成功，否则认为失败]
     */
    var resolveRet = function resolveRet(ret, code) {

        if (commonUtil.isFunction(code)) {
            return code(ret);
        } else if (commonUtil.isString(code)) {
            // 目前服务端都是以0来表示成功的
            return code && +ret[code] === 0;
        } else {
            return true;
        }
    };

    var promise = ajax(params);
    var deferred = new _Deferred2.default();
    promise.then(function (ret) {
        if (commonUtil.isFunction(filterData.parser)) {

            try {
                deferred.resolve(filterData.parser(ret));
            } catch (e) {
                e.isabort = false;
                e.status = 200;
                deferred.reject(e);
            }
        } else {
            // 失败
            if (!resolveRet(ret, filterData.codeName)) {
                if (!ret[filterData.msgName] || ret.errMsgDIY) {
                    ret[filterData.msgName] = filterData.defaultErrorMsg;
                }
                ret.isabort = false;
                ret.status = 200;
                deferred.reject(ret);
                // 成功
            } else {
                deferred.resolve(filterData.dataName && ret[filterData.dataName] || ret);
            }
        }
        xhrmap.delete(deferred.promise);
    }, function (e) {
        if (!e[filterData.msgName] || e.errMsgDIY) {
            e[filterData.msgName] = filterData.defaultErrorMsg;
        }
        deferred.reject(e);
        xhrmap.delete(deferred.promise);
    });

    // 删除旧的对应关系，加入新的对应关系
    var xhr = xhrmap.get(promise);
    xhrmap.delete(promise);
    xhrmap.set(deferred.promise, xhr);
    xhr && xhr.group && groupMap.set(xhr.group, deferred.promise);
    return deferred.promise;
}

/**
 * get请求
 * @function
 * @static
 * @since 2.0.0
 * @param {Object}  params 必选，请求参数，参数格式同ajax方法，type无需设置，默认为GET
 * @param {Object}  [filter] 可选，自定义对象，根据业务判断请求是否成功，可为空
 * @param {String|function}  [filter.codeName] 可选，当codeName为Function时，可根据返回数据自定义请求为失败或者成功；
 * 函数必须返回Boolean型，true则表示成功，即会响应Success函数，反之则响应error函数；
 * 当codeName为string时，表示返回结果里代表业务上成功与否的标识名称，其值为0时代表成功,默认为code
 * @param {String}  [filter.msgName] 可选，返回结果里代表错误消息的字段名称，默认为message
 * @param {Function}  [filter.parser] 可选，可通过此方法对返回结果进行更改，如果此方法中抛出异常，则该函数抛出异常，则该异常将会被reject状态的参数，如果返回一个对象，则将作为resolve阶段的参数
 * @param {String}  [filter.dataName] 可选，返回结果里代表实际数据的字段名称，如果该属性有值则会把对应数据取出来返回给调用方，否则把返回的所有结果返回给调用方。默认为空
 * @param {String}  [filter.defaultErrorMsg ] 可选，http请求失败时的默认错误消息，默认为“网络异常，请稍后再试”
 * @returns {Object} Promise对象
 * @example
 * //  定义code，message字段
 * xhr.get({
 *     url:'./server.php',
 *     data:{
 *         name:'rick',
 *         email:'rick@futunn.com'
 *     }
 * },{
 *      codeName: 'code',
 *      msgName: 'message',
 *      defaultErrorMsg: '网络异常，请稍后再试',
 *      dataName: ''
 * }).then(function (ret) {
 *     successFn(ret);
 * },function (error) {
 *     errorFn(error);
 * });
 *
 * // 更改返回值
 * xhr.get({
 *     url:'./server.php',
 *     data:{
 *         name:'rick',
 *         email:'rick@futunn.com'
 *     }
 * },{
 *     parser: function(ret){
 *         return {
 *             original:ret,
 *             code:10000,
 *             message:'finally ret'
 *         };
 *     }
 * }).then(function (ret) {
 *     // ret === {
 *     //     original:ret,
 *     //     code:10000,
 *     //     message:'finally ret'
 *     // }
 *     successFn(ret);
 * },function (error) {
 *     errorFn(error);
 * });
 *
 * // 更改返回值
 * xhr.get({
 *     url:'./server.php',
 *     data:{
 *         name:'rick',
 *         email:'rick@futunn.com'
 *     }
 * },{
 *     parser: function(ret){
 *          throw new Error('parse error');
 *     }
 * }).then(function (ret) {
 *     successFn(ret);
 * },function (error) {
 *     // error ===  Error('parse error')
 *     errorFn(error);
 * });
 */
function get(params, filter) {
    params = params || {};
    params.type = 'GET';
    return send(params, filter);
}

/**
 * post请求
 * @function
 * @static
 * @since 1.0.0
 * @param {Object}  params 必选，请求参数，参数格式同ajax方法，type无需设置，默认为POST
 * @param {Object}  [filter] 可选，自定义对象，根据业务判断请求是否成功，定义同get请求
 * @returns {Object} Promise对象
 * @example
 * xhr.post({
 *     url:'./server.php',
 *     data:{
 *         name:'rick',
 *         email:'rick@futunn.com'
 *     }
 * }).then(function (ret) {
 *     successFn(ret);
 * },function (error) {
 *     errorFn(error);
 * });
 */
function post(params, filter) {
    params = params || {};
    params.type = 'POST';
    return send(params, filter);
}

/**
 * abort请求
 * @function
 * @static
 * @since 2.0.0
 * @param {Object} promise 必选，发送请求时产生的promise对象
 * @param {Object} params 传递额外的参数
 * @returns {undefined} undefined
 * @example
 * // abort 请求
 * let req = xhr.ajax({
 *    url: './server.php',
 *    type: 'get',
 *    data:{
 *        name:'rick',
 *        email:'rick@futunn.com'
 *    }
 * });
 *
 * req.then(function(ret){
 *     // 请求成功
 *     console.log(ret);
 * },function(e){
 *     // 请求失败
 *     console.log(e.message);
 *     console.log(e.isabort);// true
 * });
 *
 *  xhr.abort(req);
 */
function abort(promise, params) {
    var xhr = xhrmap.get(promise);
    if (!xhr) {
        return;
    }
    if (!commonUtil.isObject(params)) {
        params = {};
    }
    if (!params.reason) {
        params.reason = "外部主动调用 abort 方法";
    }
    if (!params.abortCallBy) {
        params.abortCallBy = 'abort';
    } else {
        params.abortCallBy += ',abort';
    }
    // 把自定义的参数绑定到xhr上，方便后面查询abort的原因。
    if (params) {
        xhr[PARAMS] = params;
    }

    xhr.abort();

    // xdomainrequest 不支持onabort方法
    // xmlhttprequest经过测试，在IE9上不支持onabort方法
    // 只能手动去调用
    if (commonUtil.isIE9() && xhr.onabort) {
        params.abortCallBy = params.abortCallBy ? params.abortCallBy + ',IE9' : 'abort,IE9';
        xhr.onabort();
    }

    promise && xhrmap.delete(promise);
}